// extracted by mini-css-extract-plugin
export default {"listCloser":"ListCloser_listCloser__0bvAC","listCloserText":"ListCloser_listCloserText__SaE+G"};